import React, { useEffect, useState, useMemo } from "react";
import NormalInput from "component/common/NormalInput";
import ErrorMessage from "component/common/ErrroMessage";
import { useForm } from "react-hook-form";
import SaveCancelBtn from "component/common/SaveCancelBtn";
import usePopup from "hooks/usePopUp";

import styles from "./AddSeller.module.scss";
import { Toast } from "utils/toast";
import Popup from "component/common/Popup/Popup";
import AddButton from "component/common/AddButton";
import {
  addNewSeller,
  checkSellerUsingID,
  editSellerById,
  getSellerById,
} from "service/Payment";
import close_icon from "../../../assets/images/close_icon.png";
import { debounce } from "debounce";

const AddSeller = ({
  getSellerListData,
  showModal,
  showModalData,
  editModal,
  viewPage,
  id,
  setEditModal,
}) => {
  const { successPopUp } = usePopup();

  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    watch,
  } = useForm();

  const showModalFunc = () => {
    showModalData(true);
  };

  const handleCancel = () => {
    showModalData(false);
    setEditModal(false);
    resetFormDetails();
  };

  const [upiProduct, setUpiProduct] = useState({
    sellerProduct: "",
    UPICode: "",
  });

  const [validation, setValidation] = useState("");

  const [upiProductList, setUpiProductList] = useState({
    sellerProductList: [],
    UPICodeList: [],
    bankDetails: {},
  });

  // const [bankDetails, setBankDetails] = useState({})
  useEffect(() => {
    if (editModal && showModal) {
      getSellerDetails();
    }
  }, [showModal]);

  useEffect(() => {
    resetFormDetails();
  }, []);

  //Validating seller id
  const validateSellerUsingAPI = async (id) => {
    let response = await checkSellerUsingID(id?.value);
    if (response?.data?.message == "Seller already exist") {
      Toast({
        type: "error",
        message: response?.data?.message,
      });
    }
    setValidation(response?.data?.message);
  };
  // get seller
  const getSellerDetails = async () => {
    if (id) {
      try {
        let response = await getSellerById(id);
        if (response.status == 200) {
          console.log(response, "aasssaas");
          const {
            UPICode,
            amount,
            emailId,
            mobileNo,
            sellerAddress,
            sellerName,
            bankDetails,
            sellerProduct,
            sellerId_by_user,
            sellerId,
          } = response.data.data;
          setValue("amount", amount);
          setValue("emailId", emailId);
          setValue("mobileNo", mobileNo);
          setValue("sellerAddress", sellerAddress);
          setValue("sellerName", sellerName);
          setValue("ifscCode", bankDetails?.ifscCode);
          setValue("bankName", bankDetails?.bankName);
          setValue("accountHolderName", bankDetails?.accountHolderName);
          setValue("accountNumber", bankDetails?.accountNumber);
          setValue("sellerId_by_user", sellerId_by_user);
          setValue("sellerId", sellerId);

          setUpiProductList({
            sellerProductList: sellerProduct,
            UPICodeList: UPICode,
          });
          setUpiProduct({
            sellerProduct: "",
            UPICode: "",
          });
        }
      } catch (error) {
        // Toast({ type: "error", message: error.data.message });
      }
    }
  };

  // isEdit
  const onSubmit = async (data) => {
    let body;
    if (upiProductList?.UPICodeList.length) {
      body = {
        ...data,
        sellerProduct: upiProductList.sellerProductList,
        UPICode: upiProductList.UPICodeList,
      };
    } else {
      body = {
        ...data,
        sellerProduct: upiProductList.sellerProductList,
        UPICode: [],
        bankDetails: {
          accountHolderName: data.accountHolderName,
          bankName: data.bankName,
          accountNumber: data.accountNumber,
          ifscCode: data.ifscCode,
        },
      };
    }
    console.log(upiProductList?.UPICodeList.length, body, "length");
    if (editModal) {
      body.sellerId = data.sellerId;
      try {
        let response = await editSellerById(body);

        if (response) {
          Toast({ type: "success", message: response.data.message });
          handleCancel();
          getSellerListData();
        }
      } catch (error) {
        Toast({ type: "error", message: error.data.message });
      }
    } else {
      try {
        if (validation !== "Seller already exist") {
          let response = await addNewSeller(body);
          if (response.status == 200) {
            handleCancel();
            Toast({ type: "success", message: response.data.message });
            getSellerListData();
          }
        }
      } catch (error) {
        Toast({ type: "error", message: error.data.message });
      }
    }
  };

  const resetFormDetails = () => {
    setValue("amount", "");
    setValue("emailId", "");
    setValue("mobileNo", "");
    setValue("sellerAddress", "");
    setValue("sellerName", "");
    setValue("ifscCode", "");
    setValue("bankName", "");
    setValue("accountNumber", "");
    setValue("accountHolderName", "");
    setValue("sellerId_by_user", "");
    setValue("sellerId", "");
    setUpiProductList({
      sellerProductList: [],
      UPICodeList: [],
    });
    setUpiProduct({
      sellerProduct: "",
      UPICode: "",
    });
  };

  // change Input values for seller and upi
  const handleChange = ({ name, value }) => {
    setUpiProduct({
      [name]: value,
    });
  };

  const addListOfRecords = (name) => {
    let UPIValidation = /^[\w.-]+@[\w.-]+$/.test(upiProduct[name]);
    let dataList = upiProductList;
    console.log(dataList, "datadwr");
    let findDuplicate = dataList[name + "List"].indexOf(upiProduct[name]);
    if (findDuplicate === -1) {
      if (name === "UPICode" && UPIValidation) {
        dataList[name + "List"].push({ upi: upiProduct.UPICode });
        setUpiProductList({ ...dataList });
        setUpiProduct({
          [name]: "",
        });
        setValue(name, "");
      }
      // if(sellerProduct.length > 0){
      if (name === "sellerProduct" && !!upiProduct[name]) {
        if (/^[a-zA-Z][\sa-zA-Z]*/.test(upiProduct[name])) {
          if (/^[a-zA-Z ]*$/.test(upiProduct[name])) {
            dataList[name + "List"].push(upiProduct[name]);
            setUpiProductList({ ...dataList });
            setUpiProduct({
              [name]: "",
            });
            setValue(name, "");
          } else {
            Toast({
              type: "error",
              message: "Product name should contain only letters",
            });
          }
        } else {
          Toast({
            type: "error",
            message: "Product name should start with alphabets",
          });
        }
      }

      // }
      // else{
      //   Toast({ type: "error", message: "enter valid detail " });
      // }
    } else {
      Toast({ type: "error", message: "Already exists" });
    }
    if (!UPIValidation && name === "UPICode" && upiProduct[name] !== "") {
      Toast({ type: "error", message: "Please enter valid UPI ID" });
    }
  };

  const deleteList = (val, listName) => {
    let dataList = upiProductList;
    dataList[listName] = dataList[listName].filter((x) => x !== val);
    setUpiProductList({ ...dataList });
  };

  const { sellerProductList, UPICodeList } = upiProductList;
  const { sellerProduct, UPICode } = upiProduct;

  const ifscCode = watch("ifscCode");
  const bankName = watch("bankName");
  const accountNumber = watch("accountNumber");
  const accountHolderName = watch("accountHolderName");

  const isUPIEntered = UPICodeList?.filter((items) => items !== "");

  const isBankDetailEntered = [
    ifscCode,
    bankName,
    accountNumber,
    accountHolderName,
  ].some((data) => !!data);

  return (
    <>
      {!viewPage && (
        <AddButton label="ADD NEW SELLER" onClick={showModalFunc} />
      )}

      <Popup isOpen={showModal} setPopup={handleCancel}>
        {/* <form onSubmit={handleSubmit(onSubmit)}> */}
        <div className={styles.sell_product_form}>
          <div className={styles.sell_form_title}>
            <span>{`${editModal ? "EDIT" : "ADD NEW"} SELLER`}</span>
          </div>
          <div className="row">
            <div className="col-md-6 mb-4">
              <NormalInput
                label="Seller ID *"
                type="number"
                placeholder="Seller Id"
                register={register("sellerId_by_user", {
                  required: true,
                })}
                onChange={debounce(validateSellerUsingAPI, 1000)}
                error={errors.sellerId_by_user}
              />
              <ErrorMessage
                error={errors.sellerId_by_user}
                message={{
                  required: "Please enter seller ID",
                }}
              />
            </div>
            <div className="col-md-6 mb-4">
              <NormalInput
                label="Seller Name *"
                placeholder="Name of Seller"
                register={register("sellerName", {
                  required: true,
                  pattern: /^[a-zA-Z ]+$/,
                })}
                error={errors.sellerName}
                type="text"
              />
              <ErrorMessage
                error={errors.sellerName}
                message={{
                  required: "Please enter seller name",
                  pattern: "Please enter  text only",
                }}
              />
            </div>
            <div className="col-md-6 mb-4">
              <NormalInput
                label="Mobile Number *"
                placeholder="Enter Mobile Number"
                register={register("mobileNo", {
                  required: true,
                  pattern: /^[1-9]{1}[0-9]{9}$/,
                })}
                error={errors.mobileNo}
                type="number"
              />
              <ErrorMessage
                error={errors.mobileNo}
                message={{
                  required: "Please enter mobile number",
                  pattern: "Invalid number",
                }}
              />
            </div>
            <div className="col-md-6 mb-4">
              <NormalInput
                label="Email"
                placeholder="Enter email"
                register={register("emailId", {
                  required: false,
                  pattern:
                    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
                })}
                error={errors.emailId}
              />
              <ErrorMessage
                error={errors.emailId}
                message={{
                  required: "Please enter email id",
                  pattern: "Invalid email",
                }}
              />
            </div>
            <div className="col-md-6 mt-3">
              <NormalInput
                label="Seller UPI ID"
                placeholder="Enter UPI ID"
                register={register("UPICode", {
                  // required:isUPIEntered.length == 0 ? true : false,
                  required: false,
                })}
                error={errors.UPICode}
                onChange={handleChange}
                value={UPICode}
                readOnly={isBankDetailEntered}
              />
              <ErrorMessage
                error={errors.UPICode}
                message={{
                  required: "Please enter seller UPI ID",
                }}
              />
            </div>
            <div className="col-md-6 d-flex align-items-end">
              <button
                className={styles.addButton}
                onClick={() => addListOfRecords("UPICode")}
              >
                ADD
              </button>
            </div>

            {UPICodeList.length > 0 && (
              <div className="col-md-12 d-flex flex-wrap">
                {UPICodeList.map((val) => {
                  return (
                    <>
                      {val != "" && (
                        <div className={styles.list_card_seller}>
                          {val.upi}
                          <img
                            src={close_icon}
                            alt="Close Icon"
                            onClick={() => deleteList(val, "UPICodeList")}
                          />
                        </div>
                      )}{" "}
                    </>
                  );
                })}
              </div>
            )}
            <div className="col-md-6 mb-4 mt-4">
              <NormalInput
                label="Account Number"
                placeholder="Bank Account Number"
                register={register("accountNumber", {
                  required: isUPIEntered.length > 0 ? false : true,
                  maxLength: 20,
                  minLength: 12,
                })}
                type="number"
                readOnly={isUPIEntered.length > 0}
                value={accountNumber}
                error={errors.accountNumber}
              />
              <ErrorMessage
                error={errors.accountNumber}
                message={{
                  required: "Please enter Account Number",
                  maxLength:
                    "Account Number should not be greater than 20 characters",
                  minLength:
                    "Account Number must not be lesser than 12 characters",
                }}
              />
            </div>
            <div className="col-md-6 mb-4 mt-4">
              <NormalInput
                label="Account Holder Name"
                placeholder="Bank Account Holder Name"
                register={register("accountHolderName", {
                  required: isUPIEntered.length > 0 ? false : true,
                })}
                readOnly={isUPIEntered.length > 0}
                value={accountHolderName}
                error={errors.accountHolderName}
              />
              <ErrorMessage
                error={errors.accountHolderName}
                message={{
                  required: "Please enter Account Holder Name",
                }}
              />
            </div>
            <div className="col-md-6 mb-4">
              <NormalInput
                label="Bank Name"
                placeholder="Bank Name"
                register={register("bankName", {
                  required: isUPIEntered.length > 0 ? false : true,
                })}
                readOnly={isUPIEntered.length > 0}
                error={errors.bankName}
                value={bankName}
              />
              <ErrorMessage
                error={errors.bankName}
                message={{
                  required: "Please enter Bank Name",
                }}
              />
            </div>
            <div className="col-md-6 mb-4">
              <NormalInput
                label="IFSC Code"
                placeholder="IFSC code"
                register={register("ifscCode", {
                  required: isUPIEntered.length > 0 ? false : true,
                  maxLength: 12,
                  minLength: 8,
                })}
                readOnly={isUPIEntered.length > 0}
                error={errors.ifscCode}
                value={ifscCode}
              />
              <ErrorMessage
                error={errors.ifscCode}
                message={{
                  required: "Please enter IFSC code",
                  maxLength:
                    "IFSC code should not be greater than 12 characters",
                  minLength: "IFSC code should not be lesser than 8 characters",
                }}
              />
            </div>

            <div className="col-md-6 mb-4">
              <NormalInput
                label="Seller Address *"
                placeholder="Enter your Address"
                register={register("sellerAddress", {
                  required: true,
                })}
                error={errors.sellerAddress}
              />
              <ErrorMessage
                error={errors.sellerAddress}
                message={{
                  required: "Please enter seller address",
                }}
              />
            </div>
            <div className="col-md-6 mb-4" />
            <div className="col-md-6">
              <NormalInput
                label="Seller Products "
                placeholder="Name of the product"
                register={register("sellerProduct", {
                  required: false,
                  pattern: /^[a-zA-Z ]+$/,
                })}
                // error={errors.sellerProduct}
                onChange={handleChange}
                value={sellerProduct}
                type="text"
              />
              <ErrorMessage
                error={errors.sellerProduct}
                message={{
                  required: "Please enter seller products",
                  pattern: "Please enter  text only",
                }}
              />
            </div>
            <div className="col-md-6 d-flex align-items-end">
              <button
                className={styles.addButton}
                onClick={() => addListOfRecords("sellerProduct")}
              >
                ADD
              </button>
            </div>
            {sellerProductList?.length > 0 && (
              <div className="col-md-12 d-flex">
                {sellerProductList.map((val) => {
                  return (
                    <div className={styles.list_card_seller}>
                      {val}
                      <img
                        src={close_icon}
                        alt="Close Icon"
                        onClick={() => deleteList(val, "sellerProductList")}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        <SaveCancelBtn
          position="center"
          onCancel={() => handleCancel()}
          onSave={handleSubmit(onSubmit)}
        />
        {successPopUp()}
        {/* </form> */}
      </Popup>
    </>
  );
};

export default AddSeller;
